import { IEDistributionDto } from '../../_models';
import { ieDistributionService } from "../../_services"
import { IE_DISTRIBUTION_ACTION_TYPES, COMMON_ACTION_TYPES, APP_MESSAGES } from "../../_constants";
import {
    AddUpdateIEDistributionPayloadStructure,
    DeleteIEDistributionPayloadStructure,
    IEDistributionListFilterStructure
} from "../../_models/app.models";
import { exceptionHandler } from "../../_helpers";

const getIEDistributionList = (filters: IEDistributionListFilterStructure, onSuccess?: (d: IEDistributionDto[]) => void, onError?: (e: string) => void) => {
    return action => {
        action({ type: IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION_LIST + COMMON_ACTION_TYPES.REQUEST })
        ieDistributionService.getIEDistributionList(filters)
            .then(res => {
                action({ type: IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION_LIST + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                onSuccess && onSuccess(res.data)
            })
            .catch(error => {
                action({ type: IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION_LIST + COMMON_ACTION_TYPES.ERROR })
                onError && onError(exceptionHandler.catchError(error.response))
            })
    }
}

const updatePerWeekHour = (payload: IEDistributionListFilterStructure, onSuccess, onError?: (e: string) => void) => {
    return action => {
        action({ type: IE_DISTRIBUTION_ACTION_TYPES.UPDATE_PER_WEEK_HOURS + COMMON_ACTION_TYPES.REQUEST })
        ieDistributionService.updatePerWeekHour(payload)
            .then(res => {
                let responseMessage;
                if (res.status === 200) {
                    responseMessage = APP_MESSAGES.UPDATE_PER_WEEK_HOURS;
                }
                action({ type: IE_DISTRIBUTION_ACTION_TYPES.UPDATE_PER_WEEK_HOURS + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                onSuccess(res.data, responseMessage)
            })
            .catch(error => {
                action({ type: IE_DISTRIBUTION_ACTION_TYPES.UPDATE_PER_WEEK_HOURS + COMMON_ACTION_TYPES.ERROR })
                onError && onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getIEDistribution = (id: number, onSuccess?: (d: IEDistributionDto) => void, onError?: (e: string) => void) => {
    return action => {
        action({ type: IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION + COMMON_ACTION_TYPES.REQUEST })
        ieDistributionService.getIEDistribution(id)
            .then(res => {
                action({ type: IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                onSuccess && onSuccess(res.data)
            })
            .catch(error => {
                action({ type: IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION + COMMON_ACTION_TYPES.ERROR })
                onError && onError(exceptionHandler.catchError(error.response))
            })
    }
}

const clearIEDistributionList = () => {
    return action => {
        action({ type: IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION_LIST + COMMON_ACTION_TYPES.CLEAR })
    }
}

const addOrUpdateIEDistribution = (payload: AddUpdateIEDistributionPayloadStructure, onSuccess, onError) => {
    return action => {
        action({ type: IE_DISTRIBUTION_ACTION_TYPES.ADD_OR_UPDATE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.REQUEST })
        ieDistributionService.addOrUpdateIEDistribution(payload)
            .then(
                (res) => {
                    let responseMessage;
                    if (res.status === 200) {
                        responseMessage = APP_MESSAGES.IE_DISTRIBUTION_UPDATE_SUCCESS;
                    }
                    if (res.status === 201) {
                        responseMessage = APP_MESSAGES.IE_DISTRIBUTION_CREATE_SUCCESS;
                    }
                    action({ type: IE_DISTRIBUTION_ACTION_TYPES.ADD_OR_UPDATE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                    onSuccess(res.data, responseMessage)
                },
            )
            .catch(
                (error) => {
                    action({ type: IE_DISTRIBUTION_ACTION_TYPES.ADD_OR_UPDATE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.ERROR })
                    onError(exceptionHandler.catchError(error.response))
                }
            )

    }
}

const deleteIEDistribution = (payload: DeleteIEDistributionPayloadStructure, onSuccess?: (d: IEDistributionDto, responseMessage: string) => void, onError?: (e: string) => void) => {
    return action => {
        action({ type: IE_DISTRIBUTION_ACTION_TYPES.DELETE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.REQUEST })
        ieDistributionService.deleteIEDistribution(payload)
            .then(res => {
                let responseMessage;
                if (res.status === 200) {
                    responseMessage = APP_MESSAGES.IE_DISTRIBUTION_DELETE_SUCCESS;
                }
                action({ type: IE_DISTRIBUTION_ACTION_TYPES.DELETE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.SUCCESS, data: res.data })
                onSuccess(res.data, responseMessage)
            })
            .catch(error => {
                action({ type: IE_DISTRIBUTION_ACTION_TYPES.DELETE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.ERROR })
                onError && onError(exceptionHandler.catchError(error.response))
            })
    }
}

export const ieDistributionActions = {
    getIEDistributionList,
    getIEDistribution,
    deleteIEDistribution,
    updatePerWeekHour,
    clearIEDistributionList,
    addOrUpdateIEDistribution
};
